document.addEventListener('DOMContentLoaded', function() {
    // Handle desktop dropdown hovers with proper positioning
    const desktopDropdowns = document.querySelectorAll('.header-dropdown');
    
    desktopDropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('.header-dropdown-trigger');
        const submenu = dropdown.querySelector('.header-submenu');
        
        if (!trigger || !submenu) return;
        
        dropdown.addEventListener('mouseenter', () => {
            // Close other dropdowns first
            desktopDropdowns.forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.remove('header-dropdown-active');
                    const otherSubmenu = otherDropdown.querySelector('.header-submenu');
                    if (otherSubmenu) {
                        otherSubmenu.style.top = '';
                        otherSubmenu.style.left = '';
                    }
                }
            });
            
            // Position the current submenu
            positionSubmenu(trigger, submenu);
            
            // Open current dropdown
            dropdown.classList.add('header-dropdown-active');
        });
        
        dropdown.addEventListener('mouseleave', () => {
            dropdown.classList.remove('header-dropdown-active');
            // Reset position when closing
            submenu.style.top = '';
            submenu.style.left = '';
        });
    });

    // Function to calculate and set submenu position
    function positionSubmenu(trigger, submenu) {
        // Get trigger element position
        const triggerRect = trigger.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        // Set initial position
        let top = triggerRect.bottom;
        let left = triggerRect.left;
        
        // Temporarily show submenu to get its dimensions
        submenu.style.visibility = 'hidden';
        submenu.style.display = 'grid';
        const submenuRect = submenu.getBoundingClientRect();
        submenu.style.display = '';
        submenu.style.visibility = '';
        
        // Adjust horizontal position if submenu goes beyond viewport
        if (left + submenuRect.width > viewportWidth) {
            left = viewportWidth - submenuRect.width - 20; // 20px margin from edge
        }
        
        // Adjust vertical position if submenu goes beyond viewport
        if (top + submenuRect.height > viewportHeight) {
            top = triggerRect.top - submenuRect.height;
        }
        
        // Ensure submenu doesn't go above viewport
        if (top < 0) {
            top = 10; // 10px margin from top
        }
        
        // Apply calculated position
        submenu.style.top = `${top}px`;
        submenu.style.left = `${left}px`;
    }

    // Close all dropdowns when clicking outside (desktop only)
    document.addEventListener('click', function(e) {
        if (window.innerWidth > 768 && !e.target.closest('.header-dropdown')) {
            desktopDropdowns.forEach(dropdown => {
                dropdown.classList.remove('header-dropdown-active');
                const submenu = dropdown.querySelector('.header-submenu');
                if (submenu) {
                    submenu.style.top = '';
                    submenu.style.left = '';
                }
            });
        }
    });

    // Handle window resize for desktop dropdowns
    window.addEventListener('resize', () => {
        if (window.innerWidth > 768) {
            // Close any open dropdowns on resize
            desktopDropdowns.forEach(dropdown => {
                dropdown.classList.remove('header-dropdown-active');
                const submenu = dropdown.querySelector('.header-submenu');
                if (submenu) {
                    submenu.style.top = '';
                    submenu.style.left = '';
                }
            });
        }
    });

    // desktop submenu elements
    const desktopIconMenu = document.getElementById('desktop-icon-menu');
    const desktopNavSubmenu = document.querySelector('.desktop-nav-submenu');
    const desktopNavMenuHeader = document.getElementById('desktop-nav-menu-header');
    const desktopNavMenuBody = document.getElementById('desktop-nav-menu-body');
    const desktopNavCloseBtn = desktopNavSubmenu?.querySelector('.desktop-nav-close');

    if (desktopIconMenu && desktopNavSubmenu && desktopNavMenuHeader && desktopNavMenuBody) {
        desktopIconMenu.addEventListener('click', (e) => {
            e.preventDefault();

            const isActive = desktopNavSubmenu.classList.contains('active');

            if (isActive) {
                desktopNavSubmenu.classList.remove('active');
                desktopNavMenuHeader.classList.add('d-none');
                desktopNavMenuBody.classList.add('d-none');
                document.body.classList.remove('mobile-nav-active');
                document.body.style.overflow = '';
            } else {
                desktopNavSubmenu.classList.add('active');
                desktopNavMenuHeader.classList.remove('d-none');
                desktopNavMenuBody.classList.remove('d-none');

                // Hide mobile nav/filter if it's open (if you still keep mobile nav)
                if (mobileNavMenu) {
                    mobileNavMenu.classList.add('d-none');
                    mobileNavMenu.classList.remove('active');
                }
                if (mobileNavFilter) {
                    mobileNavFilter.classList.add('d-none');
                    mobileNavFilter.classList.remove('active');
                }

                document.body.classList.add('mobile-nav-active');
                document.body.style.overflow = 'hidden';
            }
        });

        if (desktopNavCloseBtn) {
            desktopNavCloseBtn.addEventListener('click', () => {
                desktopNavSubmenu.classList.remove('active');
                desktopNavMenuHeader.classList.add('d-none');
                desktopNavMenuBody.classList.add('d-none');
                document.body.classList.remove('mobile-nav-active');
                document.body.style.overflow = '';
            });
        }
    }

    document.querySelectorAll('.desktop-nav-submenu .desktop-dropdown-trigger').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const dropdown = trigger.closest('.desktop-dropdown');
            if (!dropdown) return;

            document.querySelectorAll('.desktop-nav-submenu .desktop-dropdown').forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.remove('active');
                }
            });

            dropdown.classList.toggle('active');
        });
    });

    // Mobile menu elements
    const mobileHamburgerBtn = document.getElementById('mobile-icon-menu');
    const mobileFilterBtn = document.getElementById('mobile-icon-filter');

    const mobileNavMenu = document.getElementById('mobile-nav-menu');
    const mobileNavFilter = document.getElementById('mobile-nav-filter');

    const mobileNavCloseButtonsMenu = mobileNavMenu ? mobileNavMenu.querySelectorAll('.mobile-nav-close') : [];
    const mobileNavCloseButtonsFilter = mobileNavFilter ? mobileNavFilter.querySelectorAll('.mobile-nav-close') : [];
    const mobileNavCloseButtons = [...mobileNavCloseButtonsMenu, ...mobileNavCloseButtonsFilter];

    const mobileNavOverlay = document.querySelectorAll('.mobile-nav-overlay');

    const mobileDropdowns = document.querySelectorAll('.mobile-dropdown');

    // Helper to show one section and hide the others
    function showMobileNavSection(section) {
        // Hide all sections first
        if (mobileNavMenu) mobileNavMenu.classList.add('d-none');
        if (mobileNavFilter) mobileNavFilter.classList.add('d-none');

        // Show requested section(s)
        if (section === 'menu') {
            if (mobileNavMenu) mobileNavMenu.classList.remove('d-none');
        } else if (section === 'filter') {
            if (mobileNavFilter) mobileNavFilter.classList.remove('d-none');
        }
    }

    // Toggle mobile menu display
    function openMobileMenu() {
        if (!mobileHamburgerBtn || !mobileNavMenu) return;

        mobileHamburgerBtn.classList.add('active');
        showMobileNavSection('menu');
        mobileNavMenu.classList.add('active');

        document.body.classList.add('mobile-nav-active');
        if (window.innerWidth <= 768) {
            document.body.style.overflow = 'hidden';
        }
    }

    function openMobileFilter() {
        if (!mobileFilterBtn || !mobileNavFilter) return;

        if (mobileNavMenu) {
            mobileNavMenu.classList.remove('active');
        }
        showMobileNavSection('filter');
        mobileNavFilter.classList.add('active');

        document.body.classList.add('mobile-nav-active');
        if (window.innerWidth <= 768) {
            document.body.style.overflow = 'hidden';
        }
    }

    function closeMobileMenu() {
        if (!mobileHamburgerBtn || !mobileNavMenu || !mobileNavFilter) return;

        mobileHamburgerBtn.classList.remove('active');
        if (mobileNavMenu) {
            mobileNavMenu.classList.add('d-none');
            mobileNavMenu.classList.remove('active');
        }
        if (mobileNavFilter) {
            mobileNavFilter.classList.add('d-none');
            mobileNavFilter.classList.remove('active');
        }

        document.body.classList.remove('mobile-nav-active');
        document.body.style.overflow = '';

        // Close all dropdowns if needed
        mobileDropdowns.forEach(dropdown => {
            dropdown.classList.remove('active');
        });
    }

    // Event listeners for mobile menu toggle
    if (mobileHamburgerBtn) {
        mobileHamburgerBtn.addEventListener('click', () => {
            if (!mobileNavMenu) return;
            if (!mobileNavMenu.classList.contains('d-none')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }

    // Event listeners for mobile filter toggle
    if (mobileFilterBtn) {
        mobileFilterBtn.addEventListener('click', () => {
            if (!mobileNavFilter) return;
            if (!mobileNavFilter.classList.contains('d-none')) {
                closeMobileMenu();
            } else {
                openMobileFilter();
            }
        });
    }

    // Event listeners for mobile nav close buttons (both menu and filter)
    mobileNavCloseButtons.forEach(btn => {
        btn.addEventListener('click', closeMobileMenu);
    });

    // Event listeners for overlays (multiple overlays possible)
    mobileNavOverlay.forEach(overlay => {
        overlay.addEventListener('click', closeMobileMenu);
    });

    // Handle mobile dropdown toggles inside menu
    mobileDropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('.mobile-dropdown-trigger');
        if (trigger) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                // Close other mobile dropdowns
                mobileDropdowns.forEach(otherDropdown => {
                    if (otherDropdown !== dropdown) {
                        otherDropdown.classList.remove('active');
                    }
                });

                // Toggle current mobile dropdown
                dropdown.classList.toggle('active');
            });
        }
    });

    // Close mobile nav when resizing to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth > 768) {
            closeMobileMenu();
        }
    });

    // Enhanced touch event handling for mobile
    let touchStartY = 0;

    document.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
        // Only prevent scroll on mobile when mobile nav is active
        if (window.innerWidth <= 768 && (mobileNavMenu.classList.contains('active') || mobileNavFilter.classList.contains('active'))) {
            const touchY = e.touches[0].clientY;
            const touchDiff = touchY - touchStartY;

            // Check if we're inside the mobile nav content
            const target = e.target;
            const mobileNavContent = target.closest('.mobile-nav-content');

            if (mobileNavContent && mobileNavContent.contains(target)) {
                // Allow scrolling within mobile nav content
                const scrollTop = mobileNavContent.scrollTop;
                const scrollHeight = mobileNavContent.scrollHeight;
                const clientHeight = mobileNavContent.clientHeight;

                // Prevent overscroll
                if ((scrollTop === 0 && touchDiff > 0) ||
                    (scrollTop + clientHeight >= scrollHeight && touchDiff < 0)) {
                    e.preventDefault();
                }
            } else {
                // Prevent scroll outside mobile nav content
                e.preventDefault();
            }
        }
    }, { passive: false });

    // Search toggle
    const desktopSearchIcon = document.getElementById('desktop-search-icon');
    if (desktopSearchIcon) {
        desktopSearchIcon.addEventListener('click', function(e) {
            e.preventDefault();
            toggleSearch();
        });
    }

    function toggleSearch() {
        const searchContainer = document.querySelector('.search-container');
        if (!searchContainer) return;
        const searchIcon = searchContainer.querySelector('#desktop-search-icon');
        const searchInput = searchContainer.querySelector('.search-desktop');
        if (!searchIcon || !searchInput) return;

        const isHidden = searchInput.classList.contains('d-none');

        if (isHidden) {
            searchInput.classList.remove('d-none');
            searchIcon.classList.add('d-none');
            const inputElem = searchInput.querySelector('input');
            if (inputElem) inputElem.focus();
        } else {
            searchInput.classList.add('d-none');
            searchIcon.classList.remove('d-none');
        }
    }

    const searchButton = document.querySelector('#header-search-button');
    const searchInput = document.querySelector('#header-search-input');

    function handleSearch() {
        const titleSearch = searchInput.value.trim();
        searchInput.value = titleSearch;
        const productsUrl = `/products?title=${encodeURIComponent(titleSearch)}`;
        window.location.href = productsUrl;
    }

    if (searchButton) {
        searchButton.addEventListener('click', handleSearch);
    }

    if (searchInput) {
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                handleSearch();
            }
        });
    }

    // Close desktop submenu when clicking outside
    document.addEventListener('click', function(e) {
        const desktopNavSubmenu = document.querySelector('.desktop-nav-submenu');
        const desktopIconMenu = document.getElementById('desktop-icon-menu');

        if (!desktopNavSubmenu || !desktopIconMenu) return;

        const isClickInsideMenu = desktopNavSubmenu.contains(e.target);
        const isClickOnIcon = desktopIconMenu.contains(e.target);

        if (!isClickInsideMenu && !isClickOnIcon && desktopNavSubmenu.classList.contains('active')) {
            desktopNavSubmenu.classList.remove('active');

            if (desktopNavMenuHeader) desktopNavMenuHeader.classList.add('d-none');
            if (desktopNavMenuBody) desktopNavMenuBody.classList.add('d-none');

            document.body.classList.remove('mobile-nav-active');
            document.body.style.overflow = '';
        }
    });
});

function handleLogout() {
    // Clear cart on logout
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
        window.location.href = '/account/logout';
    });
}

// Wrapper Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    var wrapperMenu = document.querySelector('.wrapper-menu');
    
    if (wrapperMenu) {
        wrapperMenu.addEventListener('click', function(){
            wrapperMenu.classList.toggle('open');  
        });
    }
});

// Hamburger Menu Toggle - Trigger mobile menu like #mobile-icon-menu
document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector(".hamburger");
    const mobileIconMenu = document.getElementById('mobile-icon-menu');
    const mobileNavMenu = document.getElementById('mobile-nav-menu');
    const mobileNavCloseButtons = document.querySelectorAll('.mobile-nav-close');
    
    if (hamburger && mobileIconMenu) {
        hamburger.addEventListener("click", () => {
            // Trigger the same action as #mobile-icon-menu
            mobileIconMenu.click();
            
            // Sync hamburger active state with menu state after click
            setTimeout(() => {
                if (mobileNavMenu && !mobileNavMenu.classList.contains('d-none')) {
                    hamburger.classList.add("active");
                } else {
                    hamburger.classList.remove("active");
                }
            }, 50);
        });
    }
    
    // Remove active class from hamburger when close button is clicked
    if (hamburger && mobileNavCloseButtons.length > 0) {
        mobileNavCloseButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                hamburger.classList.remove("active");
            });
        });
    }
});
